export enum ToolTestResult {
  Passed = 0,
  Failed = 1,
  NoInfo = 2
}

export enum ToolCleaningType {
  Wet = 0,
  Dry = 1,
  NoInfo = 2,
  WetAndDry = 3
}

export enum ToolFilterState {
  New = 0,
  Old = 1,
  None = 2
}

export enum ToolStatusFilter {
  MaintenanceOk = 'maintenanceOk',
  MaintenanceNotOk = 'maintenanceNotOk',
  TestOk = 'testOk',
  TestNotOk = 'testNotOk'
}